import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const TravelTourismManagementHeader = ({ componentData }) => {
  // Use componentData from CMS if available, otherwise use defaults
  const title = componentData?.title || "Travel & Tourism";
  const subtitle = componentData?.subtitle || "Management";
  const content = componentData?.content || "Explore. Serve. Inspire.";
  const backgroundImage = componentData?.mediaUrl || "https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=2072&q=80";

  return (
    <CourseHeader
      title={title}
      highlight={subtitle}
      subtitle={content}
      backgroundImage={backgroundImage}
      cta={{ label: "Start Application", targetId: "application-form" }}
    />
  );
};

export default TravelTourismManagementHeader;
